import React, { PropTypes, Component } from 'react'
import Icon from 'react-icons/lib/md/search'
import trim from 'validator/lib/trim'
import Table from 'react-bootstrap/lib/Table'
import ListGroup from 'react-bootstrap/lib/ListGroup'
import Bullet from 'react-icons/lib/md/adjust'

import FormModal from 'components/FormModal'

class SearchModal extends Component {

  componentDidMount() {
    setTimeout(() => {
      this._focus.select()
    }, 0)
  }

  _onSubmit = (e) => {
    e.preventDefault()

    const value = trim(this._focus.value)

    /*
    if (value === '') {
      return
    }*/

    this.props.onSubmit(value)
  }

  _renderForm() {
    const { placeholder } = this.props

    return (
      <form className="search-form" onSubmit={this._onSubmit}>
        <div>
          <input
            type="text"
            ref={c => this._focus = c}
            className="form-control"
            placeholder={placeholder}
          />
          <div className="add-on"><Icon /></div>
        </div>
      </form>
    )
  }

  _renderResults() {
    const { results, onSelectItem } = this.props

    if (!results || results.size === 0) {
      return null
    }


    return (
      <ListGroup fill>
        {results.map((item) => (
          <button
            key={item.get('id')}
            onClick={onSelectItem.bind(this, item)}
            className="list-group-item"
          >
            <Table hover condensed>
              <tbody>
                <tr>
                  <td width="10"><span className="btn-icon btn-inline"><Bullet /></span></td>
                  <td width="100"><small className="text-primary">{item.get('code')}</small></td>
                  <td>{item.get('name')}</td>
                </tr>
              </tbody>
            </Table>
          </button>
        ))}
      </ListGroup>
    )
  }

  render() {
    const { handleClose } = this.props
    return (
      <FormModal handleClose={handleClose}>
        <div className="search-modal">
          {this._renderForm()}
          {this._renderResults()}
        </div>
      </FormModal>
    )
  }
}

SearchModal.propTypes = {
  placeholder: PropTypes.string,
  onSubmit: PropTypes.func,
  results: PropTypes.object,
  onSelectItem: PropTypes.func,
}

export default SearchModal



// WEBPACK FOOTER //
// ./src/components/SearchModal/index.js